import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationResponse } from '@innovation-os-ng/core/auth';
import { User } from '@innovation-os-ng/core/models';
import { createAction, props, union } from '@ngrx/store';
import { AUTH_CONTEXT_PREFIX } from '../constants';
import { AuthContext } from '../interfaces/auth-context.interface';

const login = createAction(`${AUTH_CONTEXT_PREFIX} Login`, props<{ email: string; password: string; captchaSolution?: string }>());
const loginSuccess = createAction(`${login.type} Login`, props<{ authenticationResponse: AuthenticationResponse }>());
const loginError = createAction(`${login.type} Login`, props<{ error: HttpErrorResponse }>());

const reset = createAction(`${AUTH_CONTEXT_PREFIX} Reset`);

const getAuthContext = createAction(`${AUTH_CONTEXT_PREFIX} Get Auth context`);
const setAuthContextSuccess = createAction(`${getAuthContext.type} Success`, props<{ authContext: AuthContext }>());
const setAuthContextError = createAction(`${getAuthContext.type} Error`, props<{ error: HttpErrorResponse }>());

const onDeleteSpaceSuccess = createAction(`${AUTH_CONTEXT_PREFIX} Delete Space Success`, props<{ spaceUri: string }>());

/**
 * Do not use this action directly, use the `setCurrentSpace` action from space actions
 * Do not export this action from index.ts this only has internal usage 
 */
export const setCurrentAuthContextSpace = createAction(`${AUTH_CONTEXT_PREFIX} set Current Space for auth context`, props<{ spaceUri: string }>());

/**
 * Do not use this action directly, use the `setCurrentTenant` action from tenant actions
 * Do not export this action from index.ts this only has internal usage 
 */
export const setCurrentAuthContextTenant = createAction(`${AUTH_CONTEXT_PREFIX} set Current Tenant for auth context`, props<{ tenantUri: string }>());

const setUser = createAction(`${AUTH_CONTEXT_PREFIX} Set user`, props<{user: User}>());

const all = union({
  login,
  loginSuccess,
  loginError,
  reset,
  getAuthContext,
  setAuthContextSuccess,
  setAuthContextError,
  setUser,
  onDeleteSpaceSuccess
});

// exporting the type of actions here to make sure that we can use the correct type in effects
export type AuthContextActionTypes = typeof all;

export const AuthContextActions = {
  login,
  loginSuccess,
  loginError,
  reset,
  getAuthContext,
  setAuthContextSuccess,
  setAuthContextError,
  setUser,
  onDeleteSpaceSuccess
};
